<template>
	<section class="h-full">
		<div class=" h-full bg-documentGray">
			<div class="d-flex flex-column h-full">
				<main class="h-full d-flex justify-content-center align-items-center brand-main-wrapper" v-if="brandState && brands.length > 1">
							<div class="mgr-180 mgl-20 brand-left-content">
								<div class="t-headline3 t-center font-b t-line-h-48 t-headlineBlack brand-title ">It's a pleasure to meet you <br>Please select campus</div>
								<div class="t-subtitle14 font-r t-center mgt-22 t-color-bodyGrayA">Choose a campus to use</div>
							</div>
							<!-- <swiper :options="swiperOption" class="brand-swiper-container" >
								<template v-for="(brand, index) in brands"  :value="brand.code">
									<swiper-slide class="mdc-card  h-auto pdb-4" :key="index">
										<div class="" @click="selectBrand(brand)" tabindex="0">
											<img :src="brand.logo" :alt="brand.name" class="w-full" v-if="brand.logo">
											<div class="t-headline10 w-full h-full d-flex flex-column justify-content-center align-content-center" v-else>{{brand.name}}</div>
											<div
												class="brand-title d-flex align-items-center justify-content-center bg-contentBg b-radius4 flex-column cursor-pointer" >
												<div class="t-headline10 t-color-white font-rb mgt-8">{{brand.name}}</div>
												<button class="mdc-button t-color-secondaryBtnText mgt-8">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">START</span>
												</button>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide class="mdc-card  h-auto pdb-4"   :key="index">
										<div class="" @click="selectBrand(brand)" tabindex="0">
											<img :src="brand.logo" :alt="brand.name" class="w-full" v-if="brand.logo">
											<div class="t-headline10 w-full h-full d-flex flex-column justify-content-center align-content-center" v-else>{{brand.name}}</div>
											<div
												class="brand-title d-flex align-items-center justify-content-center bg-contentBg b-radius4 flex-column cursor-pointer" >
												<div class="t-headline10 t-color-white font-rb mgt-8">{{brand.name}}</div>
												<button class="mdc-button t-color-secondaryBtnText mgt-8">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">START</span>
												</button>
											</div>
										</div>
									</swiper-slide>
								</template>
							</swiper> -->
							<div class="brand-swiper-container-wrapper">
								<div class="brand-swiper-container" >
									<template v-for="(brand, index) in brands"  :value="brand.code">

										<div class="mdc-card brand-card mgt-8 mgb-8" :key="index" @click="selectBrand(brand)" @keypress="selectBrand(brand)" tabindex="0">
											<div class="" >
												<img :src="brand.logo" :alt="brand.name" class="w-full" v-if="brand.logo">
												<div class="t-headline10 w-full h-full d-flex flex-column justify-content-center align-content-center" v-else>{{brand.name}}</div>
												<div
													class="brand-title d-flex align-items-center justify-content-center bg-contentBg b-radius4 flex-column cursor-pointer" >
													<div class="t-headline10 t-color-white font-b mgt-8">{{brand.name}}</div>
													<button class="mdc-button t-color-secondaryBtnText h-auto">
														<div class="mdc-button__ripple"></div>
														<span class="mdc-button__label t-body2 font-r">START</span>
													</button>
												</div>
											</div>
										</div>
									</template>
								</div>
							</div>

				</main>
			</div>
		</div>
	</section>
</template>

<script>
/**
 * 브랜드 선택화면 컴포넌트(service select screen component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCSelect} from '@material/select'
import {MDCRipple} from '@material/ripple'
import i18nApi from '@/api/i18nApi.js'
import brandApi from '@/api/brandApi.js'
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import localStorageUtil from "@/utils/localStorageUtil";
import {storageConstants} from "@/utils/enum/StorageConstants";

export default {
	name: 'BrandSelect',
	components: {
		swiper,
		swiperSlide,
	},
	data() {
		return {
			swiperOption: {
				slidesPerView: 3,
				spaceBetween: 20,
				centeredSlides: true,
				direction:"vertical",
				breakpoints: {
					640: {
						slidesPerView: 1,
						spaceBetween: 20,
						centeredSlides: true,
					},
				}

			},
			brandState:false,
			brands: [],
			brandCode: '',
			brandName: '',
			languages: '',
			language: '',
			submitState: false,
			selectedBrandCode: '',
			showSelectBtn: false,
			lastScrollPosition: 0,
			firstBrandCard:''


		}
	},

	// 화면 노출전 브랜드 정보 설정(Set brand information before screen exposure)
	// beforeRouteEnter (to, from, next) {
	//     i18nApi.guestBrands().then((response) => {
	//         console.log('response',response)
	//         let responseBrands = response.data.data

	//         next( vm => {
	//             vm.brands = responseBrands
	//         })
	//     }).catch((err) => {
	//         next('/error')
	//     })
	// },

	beforeCreate() {
    this.$hideLoading();
    localStorageUtil.init();
		i18nApi.guestBrands().then((response) => {
			this.brands = response.data.data
			this.brandState = true;
			 if(this.brands.length < 2){
					this.selectBrand(this.brands[0]);
					this.setBrand();
			 }

			if (this.brands.length > 0) {
				const companyName = this.brands[0].companyName;
				localStorage.setItem("browserTitle", companyName);
				document.title = companyName;
			}

			// brand데이터 받아온 뒤, 다이나믹링크 브랜드코드 함수 실행
			this.hasBrandCode();
		}).catch((err) => {
			this.$router.push('/error')
		})
	},
	computed: {
		// swiper define
		swiper() {
			return this.$refs.mySwiper.swiper
		},
	},
	created() {
		window.addEventListener("resize", this.handleResize);
		this.handleResize()
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {
		this.setMaterialUi()
	},
	methods: {
		handleResize(){
			return this.firstBrandCard =  -((window.innerWidth / 3) / 2) - 10;
		},
		changeSwiperIndex(){
			if(this.$refs.mySwiper.swiper.activeIndex > 2 ){
				return this.firstBrandCard =  ((window.innerWidth / 3) / 2) - 10;
			} else {
				return this.firstBrandCard =  -((window.innerWidth / 3) / 2) - 10;
			}
			//	console.log(this.$refs.mySwiper.swiper.activeIndex, ' __dkk')
		},
		// 스크롤 이벤트 이동(on scroll event)
		onScroll(event) {
			const currentScrollPosition = event.target.scrollTop
			if (currentScrollPosition < 0) {
				return
			}
			this.showSelectBtn = currentScrollPosition > this.lastScrollPosition
			this.lastScrollPosition = currentScrollPosition
		},

		// 머티리얼 UI Attach(Materials UI Attach)
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

		},
		  
		// 다이나믹 링크에 브랜드 코드가 있을때
		hasBrandCode() {
            const dynamicQuery = JSON.parse(localStorage.getItem("DYNAMIC_QUERY"));
            if(dynamicQuery && dynamicQuery.brandCode) {
                this.selectedBrandCode = dynamicQuery.brandCode;
                this.setBrand();
                localStorage.removeItem("DYNAMIC_QUERY");
            }
        },

		// brand click
		selectBrand(brand) {
			if (this.selectedBrandCode === brand.code) {
				this.selectedBrandCode = ''
			} else {
				this.selectedBrandCode = brand.code
				this.setBrand();
			}
		},

		// click brand select button
		setBrand() {
			if (this.selectedBrandCode) {
				let findBrandInfo = _.find(this.brands, (brand) => {
					localStorage.setItem("SOCIAL_CODE", JSON.stringify(brand.social));
					return brand.code === this.selectedBrandCode
				})

				// console.log('findBrandInfo', findBrandInfo)
				// console.log('findBrandInfo', findBrandInfo)

				window.BRAND_CODE = findBrandInfo.code
				window.BRAND_NAME = findBrandInfo.name
				window.BRAND_LOGO = findBrandInfo.logo
				window.BRAND_COMPANY = findBrandInfo.companyName

				localStorage.setItem('brandCode', findBrandInfo.code)
				localStorage.setItem('brandName', findBrandInfo.name)
				localStorage.setItem('brandLogo', findBrandInfo.logo)
				localStorage.setItem('brandCompany', findBrandInfo.companyName)

				//var self =  this
				this.$showLoading();
				brandApi.brandManager().then((response) => {
					this.$hideLoading();
					window.BRAND_MANAGER_NAME = response.data.data.name
					window.BRAND_MANAGER_EMAIL = response.data.data.email
					window.BRAND_MANAGER_PHONE = response.data.data.phone
					const redirectPath = this.$route.query.redirectPath;
					if(findBrandInfo.idp) {
						localStorage.setItem(storageConstants.idpService, findBrandInfo.idp)
						window.location = localStorageUtil.getIdpUrl();
						// window.location = '/login';
					} else if(redirectPath) {
						const loginPath = `/login?redirectPath=${redirectPath}`;
                        this.$router.push(loginPath);
					} else {
						window.location = '/login';
					}
				})
			} else {
				this.$snackOpen({contents: 'Select Service', btnDisplayYN: true, btnDisplay: 'OK'}).then(() => {})
			}

		},

	}
}
</script>
